const fonts = {
  default: 13,
  title: 20,
  button: 14,
  menu: 14,
  iconsMenu: 30,
  label: 11,
  btnSubmitLoginSize: 13,
  placeholder: 14,
};

export default fonts;
